var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-system-bar',[_c('v-spacer'),_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-antenna")])],1),_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('search')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }